import { __rest } from "tslib";
const name = 'FadeScroll';
const properties = {
    schema: {},
};
const ease = 'linear';
const rangeValues = {
    in: (opacity) => ({ fromValue: opacity, toValue: 1 }),
    out: (opacity) => ({ fromValue: 1, toValue: opacity }),
};
/**
 * Fade Scroll
 */
function animate(kit, elements, _duration, _delay, _a = {}) {
    var { opacity = 0, range = 'in' } = _a, params = __rest(_a, ["opacity", "range"]);
    const sequence = kit.sequence(params);
    const { fromValue, toValue } = rangeValues[range](opacity);
    sequence.add(kit.animate('BaseFade', elements, 1000, 0, {
        from: { opacity: fromValue },
        to: { opacity: toValue },
        ease,
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=fadeScroll.js.map